// import Dashboard from "../Pages/Dashboard/Dashboard";
// import Client from "../Pages/Client/Client";
// import AddClient from "../Pages/Client/Addclientpage/addclient";
//import EmailForms from "../Pages/Emailform/Emailforms";
import CreateNew from "../Pages/SideMenu/proposal_prep_CV/CreateNew";
import Cv from "../Pages/SideMenu/proposal_prep_CV/Cv";
import Proposal from "../Pages/SideMenu/proposal_prep_CV/proposal";


const unProtectedRoutes = [
  {
    path: "/",
    component: <>Login</>,
  },
  {
    path: "/login",
    component: <>Login</>,
  },
];

const protectedRoutes = [
  {
    path: 'dashboard',
    title: 'Dashboard',
    key: "dashboard",
    // component: <EmailForms/>,
  },
  {
    path: 'emailforms',
    title: 'emailforms',
    key: "emailforms",
    component: '',
  },
  {
    path: 'addclient',
    title: 'Addclient',
    key : 'addclient' , 
    component : '',
  },
  {
    path: 'Cv',
    title: 'Cv',
    key : 'Cv' , 
    component : <Cv />,
  },

  {
    path: 'Proposal',
    title: 'Proposal',
    key : 'Proposal' , 
    component : <Proposal />,
  },
  {
    path: 'CreateNew',
    title: 'CreateNew',
    key : 'CreateNew' , 
    component : <CreateNew />,
  },
];

export const routesData = { unProtectedRoutes, protectedRoutes };